import proj4 from 'proj4';
import * as Three from 'three/webgpu';
import { z } from 'zod';

import { InstanceIdType } from '#core/schema/defs';
import { CogniteAssetModel } from '#core/schema/model/cdm/CogniteAssetModel';

import { PlatformModel } from '#schema/model/PlatformModel';

export const WellModel = z
  .object({
    ...CogniteAssetModel.shape,

    parent: PlatformModel.or(InstanceIdType).optional(),

    fullName: z.string().optional(),
    latitude: z.number(),
    longitude: z.number(),
    sector: z.string().optional(),
    slot: z.string().optional(),
    trueVerticalDepthBRT: z.number().optional(),
    measuredDepthBRT: z.number().optional(),
    welltype: z.enum(['Producer', 'Injector']),
    wellboreGeometries: InstanceIdType.array()
      .optional()
      .describe('References to wellbore geometry data for this well.'),
  })
  .transform((instance) => {
    const [x, y] = proj4('EPSG:32639', [instance.longitude, instance.latitude]);
    const position = new Three.Vector3(x, 0, -y);

    return { ...instance, position };
  });

export type WellModelInput = z.input<typeof WellModel>;
export type WellModelOutput = z.output<typeof WellModel>;
